import {
  createStore as createReduxStore,
  combineReducers,
  applyMiddleware,
} from "redux";
import { Store, RootState, RootAction } from "./types";
import thunk from "./thunk";
import { reducer as appReducer } from "./app";
import { reducer as remoteLocaleReducer } from "./remoteLocale";

export default function createStore(): Store {
  return createReduxStore(
    combineReducers({
      app: appReducer,
      remoteLocaleData: remoteLocaleReducer,
    }),
    applyMiddleware(thunk<RootState, RootAction>())
  );
}



// WEBPACK FOOTER //
// ./src/redux/createStore.ts